import React from "react";
import { Helmet } from "react-helmet";
import { BrowserRouter, Routes, Route } from "react-router-dom";
// Screens
import Landing from "./screens/Landing.jsx";
import Dashboard from "./components/dashboard/Dashboard.js";
import TrackPeriod from "./components/Period_Cycle/Tracker_Period.jsx";
import TrackPeriod2 from "./components/Period_Cycle/TrackPeriod2";
import SignUp from "./components/login/signUp.jsx";
import Login from "./components/login/Login.jsx";
import UserForm from "./components/Appointment/UserForm.js";
import BlogForm from "./components/Appointment/Blog_Form.js";
import Blog from "./components/Blog/Blog.jsx";
import BlogShow from "./components/BlogShow/BlogShow.jsx";
import DashboardBlogCard from "./components/Sections/DashboardBlogCard.jsx";
import NearClinic from "./components/nearestClinic/nearestClinic.jsx";
import NearHospital from "./components/nearestHospital/nearestHospital.jsx";
import { CrispProvider } from "./components/crisp-provider.jsx";
import ContactUs from "./components/Contact/ContactUs.jsx";
import AboutUs from "./components/Sections/AboutUs.jsx";
import FirstPeriodPage from "./components/Descperiod/FirstPeriodPage.jsx";
import Quicktips from "./components/tips/Quicktips.jsx";

export default function App() {

	return (
		<>
			<Helmet>
				<link rel="preconnect" href="https://fonts.googleapis.com" />
				<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
				<link href="https://fonts.googleapis.com/css2?family=Arimo&family=Questrial&display=swap" rel="stylesheet"
				/>
				<title>Her Bloom</title>
				{/* Telegram Widget Script */}
				<script
          async
          src="https://telegram.org/js/telegram-widget.js?22"
          data-telegram-login="HerBloom_bot"
          data-size="large"
          data-radius="10"
          data-request-access="write"
        ></script>
			</Helmet>
			<CrispProvider />
			<div className="floating-widgets">
        {/* Telegram Widget */}
        <a
          href="https://web.telegram.org/k/#@HerBloom_bot"
          target="_blank"
          rel="noopener noreferrer"
          className="telegram-widget"
        >
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/8/82/Telegram_logo.svg" // Link to Telegram logo SVG
            alt="Telegram Logo"
            className="telegram-logo"
          />
        </a>
      </div>
			<BrowserRouter>
				<Routes>
					<Route path="/" element={<Landing />} />
					<Route path="/dashboard" element={<Dashboard />} />
					<Route path="/track" element={<TrackPeriod />} />
					<Route path="/signup" element={<SignUp />} />
					<Route path="/login" element={<Login />} />
					<Route path="/appointment" element={<UserForm/>} />
					<Route path="/Healthtips" element={<Quicktips/>}/>
					<Route path="/blog" element={<Blog/>} />
					<Route path="/blog/:id" element={<BlogShow />} />
					<Route path="/dashboard/track" element={<TrackPeriod2 />} />
					<Route path="/blogform" element={<BlogForm />} />
					<Route path="/dash" element={<DashboardBlogCard />} />
					<Route path="/nearclinic" element={<NearClinic />} />
					<Route path="/nearhospital" element={<NearHospital />} />
					<Route path="/FirstPeriodDesc" element={<FirstPeriodPage/>}/>
					<Route path="/contact" element={<ContactUs/>}/>
					<Route path="/about" element={<AboutUs/>}/>
				</Routes>
			</BrowserRouter>
			  {/* Custom CSS */}
			  <style>
        {`
          .floating-widgets {
            position: fixed;
            bottom: 20px;
            right: 20px;
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            z-index: 1000;
          }

          .telegram-widget {
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #fff; /* White background for contrast */
            border-radius: 50%;
            width: 60px;
            height: 60px;
            margin-bottom: 60px; /* Space between widgets */
            text-decoration: none;
            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
          }

          .telegram-widget:hover {
            background-color: #f0f0f0;
          }

          .telegram-logo {
            width: 36px; /* Adjust size of the logo */
            height: 36px;
          }
        `}
      </style>

		</>
	);

}
